import { render, staticRenderFns } from "./CoverLetters.vue?vue&type=template&id=cc244164&scoped=true&"
import script from "./CoverLetters.vue?vue&type=script&lang=js&"
export * from "./CoverLetters.vue?vue&type=script&lang=js&"
import style0 from "./CoverLetters.vue?vue&type=style&index=0&id=cc244164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc244164",
  null
  
)

export default component.exports